import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/styles";
import { FC } from "react";

type Item = {
  icon: string;
  title: string;
  text: string;
};

interface CardGroupProps {
  items: Item[];
  showArrowIcon?: boolean;
}

const IconImg = ({ src, isMobile }: { src: string; isMobile: boolean }) => {
  return (
    <img
      src={src}
      style={{
        width: isMobile ? 20 : 40,
        height: isMobile ? 20 : 40,
      }}
      alt={src}
    />
  );
};

const CardGroup: FC<CardGroupProps> = (props) => {
  const { items, showArrowIcon } = props;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Stack
      spacing={{
        xs: 2,
        md: 4,
      }}
      direction={{
        xs: "column",
        md: "row",
      }}
    >
      {items.map(({ icon, title, text }) => (
        <Box key={title} sx={{ width: "100%" }}>
          <Stack
            spacing={3}
            sx={{
              height: "100%",
              p: 4,
              borderRadius: 4,
              backgroundColor: "rgba(255, 255, 255, 0.04)",
            }}
          >
            {!isMobile && <IconImg src={icon} isMobile={isMobile} />}
            <Stack spacing={1}>
              <Stack
                direction={"row"}
                spacing={1}
                justifyContent={isMobile ? "center" : "left"}
              >
                {isMobile && <IconImg src={icon} isMobile={isMobile} />}
                <Typography
                  fontFamily="Epilogue"
                  fontSize={{ xs: "1rem", md: "1.6rem" }}
                  fontWeight={700}
                  lineHeight={1.3}
                  align={isMobile ? "justify" : "left"}
                >
                  {title}
                </Typography>
              </Stack>
              <Typography
                fontSize={16}
                color="#FBFBFB"
                align={isMobile ? "justify" : "left"}
                pt={2}
              >
                {text}
              </Typography>
            </Stack>
          </Stack>
        </Box>
      ))}
    </Stack>
  );
};

export default CardGroup;
